module.exports = __webpack_public_path__ + "img/resources-1920.8d914bd9.jpg";